"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    label: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.grey3,
        marginBottom: 3
    },
    value: {
        display: 'flex',
        fontSize: 14,
        color: theme.grey1
    }
});
//# sourceMappingURL=groupWidget.style.js.map